"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionCardPricingInfo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const Offer_1 = require("../../molecules/Offer/Offer");
const device_1 = require("@completeanatomy/device");
const styled_components_1 = __importDefault(require("styled-components"));
const SubscriptionPrice_1 = require("../../molecules/SubscriptionPrice/SubscriptionPrice");
function SubscriptionCardPricingInfo({ isMobile, isSelected, isValidLicense, license, }) {
    var _a;
    const { t } = (0, i18n_1.useTranslation)();
    const isStudentLicense = (license === null || license === void 0 ? void 0 : license.type) === bridge_schema_1.LicenseType.StudentPlus;
    const isGerman = (0, device_1.useStateLanguage)() === 'de';
    const hasOffer = (_a = license === null || license === void 0 ? void 0 : license.product) === null || _a === void 0 ? void 0 : _a.offer;
    const mobileContent = () => {
        return hasOffer ? ((0, jsx_runtime_1.jsx)(PriceHeader, { "data-e2e": 'SubscriptionCardPricingInfo_PriceHeader', children: (0, jsx_runtime_1.jsx)(StyledOffer, { t: t, isMobile: isMobile, product: license.product, "data-e2e": 'SubscriptionCardPricingInfo_StyledOffer' }) })) : ((0, jsx_runtime_1.jsx)("div", { "data-e2e": 'SubscriptionCardPricingInfo_div' }));
    };
    const regularContent = () => {
        if (hasOffer) {
            return ((0, jsx_runtime_1.jsx)(PriceHeader, { "data-e2e": 'SubscriptionCardPricingInfo_PriceHeader', children: (0, jsx_runtime_1.jsx)(StyledOffer, { t: t, isMobile: isMobile, product: license.product, "data-e2e": 'SubscriptionCardPricingInfo_StyledOffer' }) }));
        }
        else if (!isStudentLicense) {
            return ((0, jsx_runtime_1.jsx)(PriceHeader, { "data-e2e": 'SubscriptionCardPricingInfo_PriceHeader', children: (0, jsx_runtime_1.jsxs)(List, { "data-e2e": 'SubscriptionCardPricingInfo_List', children: [(0, jsx_runtime_1.jsx)(StyledListItem, { "data-e2e": 'SubscriptionCardPricingInfo_StyledListItem', children: t(i18n_1.Strings.userOnboarding.subsSheet.buy.professional.presentation) }), (0, jsx_runtime_1.jsx)(StyledListItem, { isGerman: isGerman, "data-e2e": 'SubscriptionCardPricingInfo_StyledListItem', children: t(i18n_1.Strings.userOnboarding.subsSheet.buy.professional.rights) })] }) }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(PriceHeader, { "data-e2e": 'SubscriptionCardPricingInfo_PriceHeader' });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(PriceContainer, { isMobile: isMobile, "data-e2e": 'SubscriptionCardPricingInfo_PriceContainer', children: [isMobile ? mobileContent() : regularContent(), (0, jsx_runtime_1.jsx)(PriceContent, { isMobile: isMobile, "data-e2e": 'SubscriptionCardPricingInfo_PriceContent', children: (0, jsx_runtime_1.jsx)(StyledSubscriptionPrice, { t: t, license: license, isMobile: isMobile, isValidLicense: isValidLicense, "data-e2e": 'SubscriptionCardPricingInfo_StyledSubscriptionPrice' }) }), !isMobile && ((0, jsx_runtime_1.jsx)(BottomText, { isSelected: isSelected, "data-e2e": 'SubscriptionCardPricingInfo_BottomText', children: t(i18n_1.Strings.userOnboarding.subsSheet.buy.annual) }))] }));
}
exports.SubscriptionCardPricingInfo = SubscriptionCardPricingInfo;
const PriceContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  width: 120px;
  height: 94px;
  gap: 0px;
  justify-content: space-evenly;

  //For tablets and larger screens.
  ${({ isMobile }) => !isMobile &&
    `
      width: 224px;
      height: 158px;
      gap: 8px;
  `}
`;
const PriceHeader = styled_components_1.default.div `
  min-height: 55px;
  height: auto;
  gap: 4px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
const PriceContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 80px;
  margin-top: 0.5em;

  ${({ isMobile }) => isMobile &&
    `
      min-height: 40px;
  `};
`;
const List = styled_components_1.default.ul `
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 224px;
  height: auto;
  max-height: 40px;

  gap: 4px;
  padding-left: 1em;

  font-size: 12px;
  line-height: 1.5em;
`;
const StyledListItem = styled_components_1.default.li `
  padding-left: 0em;
  color: #4b4f55;

  &:nth-of-type(2) {
    margin: ${({ isGerman }) => (isGerman ? '0 4em' : '0 0.5em')};
  }
`;
const StyledOffer = (0, styled_components_1.default)(Offer_1.Offer) `
  height: 32px;
  margin: 0;
  color: #17242a;
`;
const StyledSubscriptionPrice = (0, styled_components_1.default)(SubscriptionPrice_1.SubscriptionPrice) `
  gap: 4px;
  margin: 1em;
`;
const BottomText = styled_components_1.default.p `
  color: #4b4f55;
  min-height: 10px;
  height: auto;
  margin: 0;
  align-self: center;

  font-size: 12px;
  ${({ isSelected }) => !isSelected && `padding-top: 4px; `};
`;
